import { render, staticRenderFns } from "./AddStartingPoint.vue?vue&type=template&id=6b74e0f2&"
import script from "./AddStartingPoint.vue?vue&type=script&lang=js&"
export * from "./AddStartingPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports